import { motion } from "framer-motion";
import { Star } from "./Star";
import { useI18n } from "@/context/LanguageContext";

export const FinalCTA = () => {
  const { content, t } = useI18n();
  const f = t.finalCta;
  return (
    <section id="rsvp" data-testid="final-cta-section" className="bg-[#141518] text-[#FFF7F1] py-20 md:py-44 relative overflow-hidden">
      <Star size={220} className="absolute -top-10 -left-16 text-[#F0311B]/15" spin />
      <Star size={180} className="absolute -bottom-10 -right-10 text-[#F0311B]/15" spin />

      <div className="max-w-[1400px] mx-auto px-4 md:px-8 relative text-center">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="font-condensed font-bold uppercase tracking-[0.25em] text-sm md:text-base text-[#FFF7F1]/70">
          {f.eyebrow}
        </motion.div>
        <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.1 }} className="mt-4 font-display font-bold text-[13vw] sm:text-7xl md:text-8xl lg:text-[9vw] leading-[0.86] text-white" data-testid="final-cta-title">
          {f.titleA} <br />
          <span className="italic text-[#F0311B]">{f.titleB}</span>
        </motion.h2>
        <motion.p initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.2 }} className="mt-8 max-w-xl mx-auto text-[#FFF7F1]/80 text-base md:text-lg">
          {f.intro}<span className="text-[#FFF7F1]">{f.deadline}</span>{f.introTail}
        </motion.p>
        <motion.a href={content.rsvpUrl} target="_blank" rel="noopener noreferrer" data-testid="final-rsvp-button" initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.3 }} className="group mt-10 inline-flex items-center justify-center gap-3 md:gap-4 bg-[#F0311B] text-white w-full sm:w-auto px-6 md:px-12 py-5 md:py-6 text-xs sm:text-sm md:text-base uppercase tracking-[0.22em] md:tracking-[0.3em] font-bold border-2 border-white shadow-[6px_6px_0_0_#7AD5DC] md:shadow-[10px_10px_0_0_#7AD5DC] hover:translate-x-[3px] hover:translate-y-[3px] hover:shadow-[3px_3px_0_0_#7AD5DC] md:hover:shadow-[6px_6px_0_0_#7AD5DC] transition-all">
          {f.cta}
          <span className="inline-block transition-transform group-hover:translate-x-2">→</span>
        </motion.a>
      </div>
    </section>
  );
};
